export enum EAdminUrl {
  PROPERTY_MANAGEMENT = 'property-management',
  HUB_SPOT = 'hub-spot',
  DISABLE = 'disable',
  PLAN = 'plan',
  COURSES = 'courses',
  SHOULD_TENANT_SIGN = 'should-tenant-sign',
  REPORTS = 'reports',
  ENABLE = 'enable',
  NOT_SYNCED_ANIMALS_COUNT = 'not-synced-animals-count',
  NOTES = 'notes',
}